import React from 'react';
import axios from 'axios';
import './SnakeBoard.css';
import Snake from './Snake';
import Food from './Food';
import User from './User';
import Result from './Result';
import DocumentMeta from 'react-document-meta';
import { DateTime } from 'luxon'
import '../Navigation/Games.css';

const getRandomCoordinates = () => {
  let min = 1;
  let max = 97;
  let x = Math.floor((Math.random() * (max - min + 1) + min) / 2) * 2;
  let y = Math.floor((Math.random() * (max - min + 1) + min) / 2) * 2;
  return[x,y];
}

const meta = {
    title: 'Snake Game',
    description: 'Snake Game',
    canonical: 'https://timepassgame.com/snake-game',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'snakegame, timepassgame, snake, timepass, games'
        }
    }
}

class SnakeBoard extends React.Component {
  state = {
    snakeDots: [[0, 0], [2, 0]],
    food: getRandomCoordinates(),
    direction: "RIGHT",
    speed: 500,
    userName: '',
    defaultUser: '',
    level: 'Easy',
    showToppers: false,
    toprankers: [],
    isPaused: false,
    gameStarted: false,
    gameOver: false
  }

  start = '';

  componentDidMount = () => {
    //setInterval(this.moveSnake, this.state.speed);
    document.onkeydown = this.onKeyDown;
    // Add class to prevent scrolling
    document.body.classList.add('snake-game-active');
  }
  componentDidUpdate = () => {
    if (this.state.gameOver) return;
    this.checkBorders();
    this.checkIfCollapsed();
    this.checkIfEat();    
  }
  
  componentWillUnmount = () => {
    clearInterval(this.start);
    // Remove class to restore scrolling
    document.body.classList.remove('snake-game-active');
    document.onkeydown = null;
  }

  initialState = () => {
    clearInterval();
    this.setState({
    snakeDots: [[0, 0], [2, 0]],
    food: getRandomCoordinates(),
    direction: "RIGHT",
    speed: 500,
    userName: '',
    defaultUser: '',
    level: 'Easy',
    showToppers: true,
    isPaused: false,
    gameStarted: false,
    gameOver: false
    });
}

  onKeyDown = e => {
    if (this.state.isPaused || !this.state.gameStarted) return;
    
    e = e || window.event;
    
    // Prevent default behavior for arrow keys and spacebar to stop page scrolling
    if ([37, 38, 39, 40, 32].includes(e.keyCode)) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    switch(e.keyCode) {
      case 37:
        this.setState({ direction: "LEFT" });
        break;
      case 38: 
        this.setState({ direction: "UP" });
        break;
      case 39:
        this.setState({ direction: "RIGHT" });
        break;
      case 40:
        this.setState({ direction: "DOWN" });
        break;
      case 32: // Spacebar for pause
        this.togglePause();
        break;
    }
  }
  handleClick =(e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (this.state.isPaused || !this.state.gameStarted) return;
    
    // Find the button element even if a child element (span) was clicked
    let buttonElement = e.target;
    while (buttonElement && buttonElement.tagName !== 'BUTTON') {
      buttonElement = buttonElement.parentElement;
    }
    
    if (buttonElement && (buttonElement.id || buttonElement.dataset.direction)) {
      const direction = buttonElement.id || buttonElement.dataset.direction;
      this.setState({
        direction: direction
      });
    }
  }
  moveSnake = () => {
    if (this.state.isPaused || this.state.gameOver) return;
    
    let dots = [...this.state.snakeDots];
    let head = dots[dots.length - 1];

    switch (this.state.direction) {
      case "LEFT": 
        head = [head[0] - 2, head[1]];
        break;
      case "UP": 
        head = [head[0], head[1] - 2];
        break;
      case "RIGHT": 
        head = [head[0] + 2, head[1]];
        break;
      case "DOWN": 
        head = [head[0], head[1] + 2];
        break;
    }
    dots.push(head);
    dots.shift();
    this.setState({
      snakeDots: dots
    });
  }
  checkBorders = () => {
    if (this.state.gameOver) return;
    let head = this.state.snakeDots[this.state.snakeDots.length - 1];
    if(head[0] >= 100 || head[1] >= 100 || head[0] < 0 || head[1] < 0 ) {
      this.onGameOver();
    }
  }
  onGameOver = () => {
    if (this.state.gameOver) return; // Prevent multiple calls
    
    clearInterval(this.start);
    this.setState({ gameOver: true }, () => {
      this.toppers();
    });
  }
  newGame = () => {
    this.setState({
      snakeDots: [[0, 0], [2, 0]],
      food: getRandomCoordinates(),
      direction: "RIGHT",
      speed: 500,
      userName: '',
      defaultUser: '',
      level: 'Easy',
      showToppers: false,
      toprankers: [],
      isPaused: false,
      gameStarted: false,
      gameOver: false
    });
  }
   toppers = () => {   
     const now = DateTime.now();
     const formattedDate = now.toFormat('dd-MM-yyyy HH:mm:ss');

   const toppers = {
     userName: this.state.userName,
     score: this.state.snakeDots.length - 2,
     level: this.state.level,
     time: formattedDate
   }
   axios.post("/snake.json", toppers)
   .then(response => {
     console.log('Score saved successfully');
     // Automatically get the leaderboard data after saving
     this.getToppers();
   })
   .catch(error => {
     console.log('Error saving score:', error);
     // Even if saving fails, try to get existing leaderboard data
     this.getToppers();
   });
 }
 getToppers = () => {
   console.log('getToppers called - fetching leaderboard data...');
   axios.get("/snake.json")
   .then(response => {
     console.log('API Response:', response.data);
     const fetchedResults = [];
     for(let key in response.data){
       fetchedResults.unshift(
         {
           ...response.data[key],
           id: key
         }
       )
     }
     const sortedResults = fetchedResults.sort((a,b) => (b.score - a.score));
     console.log('Processed leaderboard data:', sortedResults);
     this.setState({
       toprankers: sortedResults,
       showToppers: true
     });
   })
   .catch(error => {
     console.log('Error fetching leaderboard:', error);
     // Even if there's an error, show the result section with empty leaderboard
     this.setState({
       toprankers: [],
       showToppers: true
     });
   });
 }
  checkIfCollapsed = () => {
    if (this.state.gameOver) return;
    let snake = [...this.state.snakeDots];
    let head = snake[snake.length - 1];
    snake.pop();
    snake.forEach(dot => {
      if(head[0] == dot[0] && head[1] == dot[1]) {
        this.onGameOver();
      }
    })
  }
  checkIfEat = () => {
    let head = this.state.snakeDots[this.state.snakeDots.length - 1];
    let food = this.state.food;
    if(head[0] == food[0] && head[1] == food[1]) {
      this.setState({
        food: getRandomCoordinates()
      })
        this.enlargeSnake();
    }
  }
  enlargeSnake = () => {
      let newSnake = [...this.state.snakeDots];
      newSnake.unshift([]);
      this.setState({
        snakeDots: newSnake,
        speed: this.state.speed - 10
      });
  }

  handleChange = (event) => {
    this.setState({
      defaultUser: event.target.value
    });
  }
  changeLevel = (event) => {
    this.setState({
      level: event.target.value
    })
  }
  handleSubmit = () => {
    // Validate that name is not empty and has at least 2 characters
    const trimmedName = this.state.defaultUser.trim();
    if(trimmedName === '' || trimmedName.length < 2) {
      alert('Please enter a valid name (at least 2 characters)');
      return;
    }
    
    this.setState({
      userName: trimmedName,
      gameStarted: true
    });
    
    // Start the game based on selected level
    if(this.state.level === 'Easy') {
      this.start = setInterval(this.moveSnake, 400);
    }
    if(this.state.level === 'Medium') {
      this.start = setInterval(this.moveSnake, 200);
    }
    if(this.state.level === 'Expert') {
      this.start = setInterval(this.moveSnake, 100);
    }
  }
  
  togglePause = () => {
    if (this.state.isPaused) {
      // Resume game
      if(this.state.level === 'Easy') {
        this.start = setInterval(this.moveSnake, 400);
      }
      if(this.state.level === 'Medium') {
        this.start = setInterval(this.moveSnake, 200);
      }
      if(this.state.level === 'Expert') {
        this.start = setInterval(this.moveSnake, 100);
      }
      this.setState({ isPaused: false });
    } else {
      // Pause game
      clearInterval(this.start);
      this.setState({ isPaused: true });
    }
  }
  
  render() {
    return(
      <div className="Games-page">
      <DocumentMeta {...meta} />
      <div className="side-bar"></div>
      <div className="Game-Container">
      <div className="snake-game-header">
        <div className="snake-info-panel">
          <div className="snake-info-item">
            <p className="snake-score-label">SCORE</p>
            <p className="snake-score">{this.state.snakeDots.length - 2}</p>
          </div>
          <div className="snake-info-item">
            <p className="snake-level-label">LEVEL</p>
            <p className="snake-level">{this.state.level}</p>
          </div>
        </div>
      </div>
      {this.state.gameStarted && !this.state.gameOver && (
        <button 
          onClick={this.togglePause} 
          className="snake-pause-button"
        >
          {this.state.isPaused ? '▶️' : '⏸️'}
        </button>
      )}
      <div className="snake-board">
        <Snake snakeDots={this.state.snakeDots} />
        <Food dot={this.state.food} />
        {this.state.isPaused && (
          <div className="snake-pause-overlay">
            <h2>PAUSED</h2>
            <p>Click Play to continue</p>
          </div>
        )}
      </div>
      {this.state.gameStarted && !this.state.isPaused && !this.state.gameOver && (
        <div className="snake-controls-horizontal">
          <button onClick={this.handleClick} className="snake-control-button" id="LEFT" data-direction="LEFT">
            <span className="control-arrow">←</span>
            <span className="control-label">LEFT</span>
          </button>
          <button onClick={this.handleClick} className="snake-control-button" id="UP" data-direction="UP">
            <span className="control-arrow">↑</span>
            <span className="control-label">UP</span>
          </button>
          <button onClick={this.handleClick} className="snake-control-button" id="DOWN" data-direction="DOWN">
            <span className="control-arrow">↓</span>
            <span className="control-label">DOWN</span>
          </button>
          <button onClick={this.handleClick} className="snake-control-button" id="RIGHT" data-direction="RIGHT">
            <span className="control-arrow">→</span>
            <span className="control-label">RIGHT</span>
          </button>
        </div>
      )}
      {
        (this.state.userName === '' && !this.state.showToppers) ? 
        <User handleChange = {this.handleChange} 
         handleSubmit = {this.handleSubmit} 
         changeLevel = {this.changeLevel} /> : null
      }
      {this.state.gameStarted && !this.state.showToppers && !this.state.gameOver && (
        <div className="snake-instructions">
          <p>🎮 Use arrow keys or buttons to control the snake</p>
          <p>🍎 Eat the golden food to grow</p>
          <p>⏸️ Press spacebar or pause button to pause</p>
          <p>⚠️ Don't hit walls or yourself!</p>
        </div>
      )}
      {
        (this.state.showToppers === true) ? 
        <Result newgame={this.newGame} 
        toprankers={this.state.toprankers} 
        showToppers={this.state.showToppers}
        score={this.state.snakeDots.length - 2}
        userName={this.state.userName} /> 
        : null
      }
      </div>      
      <div className="side-bar"></div>
    </div>
    );
  }
}
export default SnakeBoard;